/**
 * Projects Filter — Tab-Filter für rsce_projects
 *
 * Tabs mit data-filter="all|laufend|abgeschlossen" steuern Karten mit data-status.
 * Empty-State (data-projects-empty) erscheint, wenn 0 Karten matchen.
 * Mehrere Instanzen pro Seite möglich — scoped pro .ds-projects-Section.
 */

function applyFilter(scope, value) {
  const tabs = scope.querySelectorAll("[data-filter]");
  const cards = scope.querySelectorAll(".ds-project-card");
  const empty = scope.querySelector("[data-projects-empty]");

  tabs.forEach((t) => {
    const active = t.dataset.filter === value;
    t.classList.toggle("is-active", active);
    t.setAttribute("aria-selected", active ? "true" : "false");
  });

  let visible = 0;
  cards.forEach((card) => {
    const match = value === "all" || card.dataset.status === value;
    card.hidden = !match;
    if (match) visible++;
  });

  if (empty) empty.hidden = visible !== 0;
}

export function init() {
  const sections = document.querySelectorAll(".ds-projects");
  if (sections.length === 0) return;

  sections.forEach((section) => {
    const tabs = section.querySelectorAll("[data-filter]");
    if (tabs.length === 0) return;
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => applyFilter(section, tab.dataset.filter));
    });
  });
}
